import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/schemas_analytics_event.py
export const SCHEMAS_ANALYTICS_ACTIONS = {
  // READ actions
  FILTERED_BY_COMPUTED_FIELD_OVER_RESULTS: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'filtered_by_computed_field_over_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INTEGRATION_FIELD_BLOCKED_REVIEW: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'integration_field_blocked_review',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_EDIT_SCHEMA_AS_JSON: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'clicked_edit_schema_as_json',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_EDIT_SCHEMA_VIA_UI: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'clicked_edit_schema_via_ui',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // WRITE actions
  CANCEL_FIELD_MIGRATION: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'cancel_field_migration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_COMPUTED_FIELD_OVER_RESULTS: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'created_computed_field_over_results',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_RESULT_SCHEMA_VIA_SPREADSHEET: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'created_result_schema_via_spreadsheet',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_SNAPSHOT_FIELD_CONFIGURATION: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'created_snapshot_field_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_DROPDOWN_VIA_SPREADSHEET: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'created_dropdown_via_spreadsheet',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OVERRODE_INTEGRATION_TAG_VALUE: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'overrode_integration_tag_value',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PUBLISH_FIELD_MIGRATION: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'publish_field_migration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_LEGAL_TEXT_SELECTOR: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'set_legal_text_selector',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_LEGAL_TEXT_VALUE: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'set_legal_text_value',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  START_FIELD_MIGRATION: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'start_field_migration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_SNAPSHOT_FIELD_CONFIGURATION: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'updated_snapshot_field_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  USED_RESULT_SCHEMA_SPREADSHEET_IMPORTER: {
    module: ANALYTICS_MODULE.SCHEMAS,
    action: 'used_result_schema_spreadsheet_importer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
